import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { Spinner } from 'UI';
import { Checkbox, Flex, Button, Icon, TooltipMenu, Skeleton } from '@haldor/ui';
import { Search as SearchInput } from 'UI/Inputs';
import { DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { searchSubjects } from 'actions/subjects';

var TeacherRoleForm = /*#__PURE__*/function (_Component) {
  _inherits(TeacherRoleForm, _Component);

  var _super = _createSuper(TeacherRoleForm);

  function TeacherRoleForm(props) {
    var _this;

    _classCallCheck(this, TeacherRoleForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      _this.props.onTeacherRoleSubmit(_this.state.selectedSubjects);

      _this.setState({
        selectedSubjects: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      _this.props.searchSubjects(value.query);

      _this.setState({
        selectedSubjects: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectSubject", function (subject) {
      if (_this.state.selectedSubjects.findIndex(function (ss) {
        return ss.is == subject.id;
      }) > -1) {
        _this.setState({
          selectedSubjects: _this.state.selectedSubjects.filter(function (t) {
            return t.id != subject.id;
          })
        });
      } else {
        _this.setState({
          selectedSubjects: [].concat(_toConsumableArray(_this.state.selectedSubjects), [subject])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubject", function (subject, index) {
      var subjectIndex = -1;

      if (_this.props.previousTeacherRoles != null && _this.props.previousTeacherRoles != '') {
        subjectIndex = _this.props.previousTeacherRoles.findIndex(function (r) {
          return r.subjectCode == subject.subjectCode;
        });
      }

      if (subjectIndex < 0) {
        return /*#__PURE__*/React.createElement(RowItem, {
          key: 'row-id-' + index
        }, /*#__PURE__*/React.createElement(RowCell, {
          title: _this.props.translate('name')
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: _this.state.selectedSubjects.find(function (t) {
            return t.id == subject.id;
          }) != null,
          onChange: function onChange() {
            return _this.selectSubject(subject);
          },
          label: subject.title //disabled={this.state.selectedCourses.find(t => t.userId == user.userId) != null}

        })), /*#__PURE__*/React.createElement(RowCell, {
          title: _this.props.translate('school')
        }, _this.props.translate(subject.typeOfSchooling)), /*#__PURE__*/React.createElement(RowCell, {
          title: _this.props.translate('subject-code')
        }, subject.subjectCode));
      }
    });

    _this.state = {
      selectedSubjects: []
    };
    return _this;
  }

  _createClass(TeacherRoleForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('search-for-courses')), /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: this.props.translate('search'),
        onSubmit: this.onSearch,
        autofocus: true,
        lengthLimit: 3
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('subjects'),
        data: this.props.subjects,
        renderRow: this.renderSubject,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit",
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "save",
        disabled: submitting || !valid
      }, this.props.translate('save')))));
    }
  }]);

  return TeacherRoleForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    subjects: state.Subjects.search
  };
}

export default connect(mapStateToProps, {
  searchSubjects: searchSubjects
})(reduxForm({
  form: 'AddTeacherRole',
  destroyOnUnmount: true
})(TeacherRoleForm));